module.exports = {"230306001":"城子河街道","230306002":"正阳街道","230306003":"东海街道","230306004":"城西街道","230306005":"杏花街道","230306200":"长青乡","230306201":"永丰乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230306.json
// module id = 710
// module chunks = 0